import { jsonSchema, type UIMessage } from 'ai';

export type MimDataParts = {
  message: string;
  choices: string[];
  'subagent-open': string;
  'subagent-close': string;
};

export type MimUIMessage = UIMessage<never, MimDataParts>;

/** Responds with a message to the user.
 *  If choices are available from the output of the LLM,
 *  present them as options for the user to select. */
export const structuredResponseSchema = jsonSchema<{
  message: string;
  choices?: string[];
}>({
  type: 'object',
  properties: {
    message: { type: 'string' },
    choices: {
      type: 'array',
      items: { type: 'string' },
    },
  },
  required: ['message'],
  additionalProperties: false,
});
